export default __webpack_public_path__ + "static/media/DNo.29-4.954e060e.jpg";